export const defaultThunderHits = {
    ohlHits: [
        //{ohl: '', pole: '', poleItemIndex: '', position: {lat: '', lng: ''}, time: '' },
        {ohl: 'DV 277 TS BEOGRAD 8 - TS SMEDEREVO 3', pole: '83', poleItemIndex: 85, position: {lat: 44.589880, lng: 20.901190}, time: '17/9/2019 9:56:2', length: 5.25, stationName: 'Smederevo 3', isOutage: true },
        {ohl: 'DV 401/1 TS BEOGRAD 8 - RP DRMNO', pole: '26', poleItemIndex: 27, position: {lat: 44.669690, lng: 20.660978}, time: '17/9/2019 9:58:2', length: 9.1, stationName: '', isOutage: false },
        {ohl: 'DV 1109 TS BEOGRAD 7 - TS PANČEVO 2', pole: '21', poleItemIndex: 22, position: {lat: 44.877215, lng: 20.518647}, time: '17/9/2019 9:59:2', length: 7.7, stationName: '',isOutage: false },
        {ohl: 'DV 277 TS BEOGRAD 8 - TS SMEDEREVO 3', pole: '56', poleItemIndex: 58, position: {lat: 44.621928, lng: 20.775770}, time: '17/9/2019 10:00:1', length: 14.7, stationName: '', isOutage: false },
        {ohl: 'DV 453 RP DRMNO - TS PANČEVO 2', pole: '101', poleItemIndex: 102, position: {lat: 44.825453, lng: 20.853264}, time: '17/9/2019 10:07:41', length: 17.5, stationName: 'Pancevo 2', isOutage: true },
    ],
    regions: [
        { 
            ohl: 'DV 277 TS BEOGRAD 8 - TS SMEDEREVO 3',
            poles:
                [{ index: 85, name: '83', lat: 44.5901 , lng: 20.9009, sys: 1},
                { index: 86, name: '84', lat: 44.5907 , lng: 20.9038, sys: 1},
                { index: 87, name: '85', lat: 44.592 , lng: 20.9098, sys: 1},
                { index: 88, name: '86', lat: 44.593 , lng: 20.9144, sys: 1},
                { index: 89, name: '87', lat: 44.5941 , lng: 20.9192, sys: 1},
                { index: 90, name: '88', lat: 44.5951 , lng: 20.924, sys: 1},
                { index: 91, name: '89', lat: 44.5961 , lng: 20.9288, sys: 1},
                { index: 92, name: '90', lat: 44.5971 , lng: 20.9333, sys: 1},
                { index: 93, name: '91', lat: 44.5981 , lng: 20.9379, sys: 1},
                { index: 94, name: '92', lat: 44.5989 , lng: 20.942, sys: 1},
                { index: 95, name: '93', lat: 44.5979 , lng: 20.9457, sys: 1},
                { index: 96, name: '94', lat: 44.5967 , lng: 20.9502, sys: 1},
                { index: 97, name: '95', lat: 44.5955 , lng: 20.9549, sys: 1},
                { index: 98, name: '96', lat: 44.5944 , lng: 20.9589, sys: 1},
                { index: 99, name: '97', lat: 44.5951 , lng: 20.9628, sys: 1},
                { index: 100, name: 'P-99', lat: 44.5961 , lng: 20.963, sys: 1, portal: true}],
            isOutage: true
        },
        { 
            ohl: 'DV 401/1 TS BEOGRAD 8 - RP DRMNO',
            poles: [
            { index: 1, name: 'P-01', lat: 44.7353, lng: 20.5884, sys: 1, portal: true },
            { index: 2, name: '1', lat: 44.7347, lng: 20.5898, sys: 1 },
            { index: 3, name: '2', lat: 44.733, lng: 20.5936, sys: 1 },
            { index: 4, name: '3', lat: 44.729, lng: 20.5938, sys: 1 },
            { index: 5, name: '4', lat: 44.7249, lng: 20.5939, sys: 1 },
            { index: 6, name: '5', lat: 44.7203, lng: 20.5941, sys: 1 },
            { index: 7, name: '6', lat: 44.716, lng: 20.5943, sys: 1 },
            { index: 8, name: '7', lat: 44.7116, lng: 20.5945, sys: 1 },
            { index: 9, name: '8', lat: 44.7086, lng: 20.5946, sys: 1 },
            { index: 10, name: '9', lat: 44.7054, lng: 20.5986, sys: 1 },
            { index: 11, name: '10', lat: 44.7035, lng: 20.6009, sys: 1 },
            { index: 12, name: '11', lat: 44.7005, lng: 20.6047, sys: 1 },
            { index: 13, name: '12', lat: 44.6981, lng: 20.6077, sys: 1 },
            { index: 14, name: '13', lat: 44.696, lng: 20.6103, sys: 1 },
            { index: 15, name: '14', lat: 44.6935, lng: 20.6134, sys: 1 },
            { index: 16, name: '15', lat: 44.6909, lng: 20.6167, sys: 1 },
            { index: 17, name: '16', lat: 44.6894, lng: 20.6186, sys: 1 },
            { index: 18, name: '17', lat: 44.685, lng: 20.624, sys: 1 },
            { index: 19, name: '18', lat: 44.6835, lng: 20.626, sys: 1 },
            { index: 20, name: '19', lat: 44.6792, lng: 20.6313, sys: 1 },
            { index: 21, name: '20', lat: 44.6781, lng: 20.6332, sys: 1 },
            { index: 22, name: '21', lat: 44.6767, lng: 20.6354, sys: 1 },
            { index: 23, name: '22', lat: 44.6745, lng: 20.6391, sys: 1 },
            { index: 24, name: '23', lat: 44.6729, lng: 20.6458, sys: 1 },
            { index: 25, name: '24', lat: 44.672, lng: 20.6504, sys: 1 },
            { index: 26, name: '25', lat: 44.6711, lng: 20.6545, sys: 1 },
            { index: 27, name: '26', lat: 44.6696, lng: 20.6613, sys: 1 },]
        },
        {
            ohl: 'DV 1109 TS BEOGRAD 7 - TS PANČEVO 2',
            poles:[
            { index: 1, name: 'P-07', lat: 44.8429 , lng: 20.4924, sys: 1, portal: true},
            { index: 2, name: '1', lat: 44.843 , lng: 20.4932, sys: 1},
            { index: 3, name: '2', lat: 44.8437 , lng: 20.4948, sys: 1},
            { index: 4, name: '3', lat: 44.8444 , lng: 20.4964, sys: 1},
            { index: 5, name: '4', lat: 44.8454 , lng: 20.4987, sys: 1},
            { index: 6, name: '5', lat: 44.847 , lng: 20.5003, sys: 1},
            { index: 7, name: '6', lat: 44.8485 , lng: 20.5019, sys: 1},
            { index: 8, name: '7', lat: 44.8501 , lng: 20.5035, sys: 1},
            { index: 9, name: '8', lat: 44.8512 , lng: 20.5048, sys: 1},
            { index: 10, name: '9', lat: 44.8527 , lng: 20.5066, sys: 1},
            { index: 11, name: '10', lat: 44.8546 , lng: 20.5088, sys: 1},
            { index: 12, name: '11', lat: 44.8567 , lng: 20.5113, sys: 1},
            { index: 13, name: '12', lat: 44.8585 , lng: 20.5133, sys: 1},
            { index: 14, name: '13', lat: 44.8605 , lng: 20.5158, sys: 1},
            { index: 15, name: '14', lat: 44.8618 , lng: 20.5172, sys: 1},
            { index: 16, name: '15', lat: 44.8632 , lng: 20.5174, sys: 1},
            { index: 17, name: '16', lat: 44.8653 , lng: 20.5177, sys: 1},
            { index: 18, name: '17', lat: 44.8675 , lng: 20.518, sys: 1},
            { index: 19, name: '18', lat: 44.8699 , lng: 20.5184, sys: 1},
            { index: 20, name: '19', lat: 44.8724 , lng: 20.5187, sys: 1},
            { index: 21, name: '20', lat: 44.8748 , lng: 20.5191, sys: 1},
            { index: 22, name: '21', lat: 44.8772 , lng: 20.5194, sys: 1}
        ]},
        {
            ohl: 'DV 277 TS BEOGRAD 8 - TS SMEDEREVO 3',
            poles : [
            { index: 58, name: '56', lat: 44.6222 , lng: 20.7754, sys: 1},
            { index: 59, name: '57', lat: 44.6208 , lng: 20.7783, sys: 1},
            { index: 60, name: '58', lat: 44.6182 , lng: 20.7841, sys: 1},
            { index: 61, name: '59', lat: 44.6163 , lng: 20.7881, sys: 1},
            { index: 62, name: '60', lat: 44.6148 , lng: 20.7914, sys: 1},
            { index: 63, name: '61', lat: 44.6129 , lng: 20.7957, sys: 1},
            { index: 64, name: '62', lat: 44.6113 , lng: 20.7992, sys: 1},
            { index: 65, name: '63', lat: 44.6118 , lng: 20.8016, sys: 1},
            { index: 66, name: '64', lat: 44.611 , lng: 20.8048, sys: 1},
            { index: 67, name: '65', lat: 44.6102 , lng: 20.8084, sys: 1},
            { index: 68, name: '66', lat: 44.6088 , lng: 20.814, sys: 1},
            { index: 69, name: '67', lat: 44.6075 , lng: 20.8192, sys: 1},
            { index: 70, name: '68', lat: 44.6055 , lng: 20.8268, sys: 1},
            { index: 71, name: '69', lat: 44.6043 , lng: 20.8312, sys: 1},
            { index: 72, name: '70', lat: 44.6023 , lng: 20.8384, sys: 1},
            { index: 73, name: '71', lat: 44.6013 , lng: 20.8422, sys: 1},
            { index: 74, name: '72', lat: 44.5998 , lng: 20.8479, sys: 1},
            { index: 75, name: '73', lat: 44.598 , lng: 20.8546, sys: 1},
            { index: 76, name: '74', lat: 44.5967 , lng: 20.8593, sys: 1},
            { index: 77, name: '75', lat: 44.596 , lng: 20.8636, sys: 1},
            { index: 78, name: '76', lat: 44.5954 , lng: 20.8671, sys: 1},
            { index: 79, name: '77', lat: 44.5947 , lng: 20.8721, sys: 1},
            { index: 80, name: '78', lat: 44.5938 , lng: 20.8773, sys: 1},
            { index: 81, name: '79', lat: 44.5932 , lng: 20.8814, sys: 1},
            { index: 82, name: '80', lat: 44.5925 , lng: 20.8855, sys: 1},
            { index: 83, name: '81', lat: 44.5916 , lng: 20.8911, sys: 1},
            { index: 84, name: '82', lat: 44.5908 , lng: 20.8965, sys: 1},
            { index: 85, name: '83', lat: 44.5901 , lng: 20.9009, sys: 1},
            { index: 86, name: '84', lat: 44.5907 , lng: 20.9038, sys: 1},
            { index: 87, name: '85', lat: 44.592 , lng: 20.9098, sys: 1},
            { index: 88, name: '86', lat: 44.593 , lng: 20.9144, sys: 1},
            { index: 89, name: '87', lat: 44.5941 , lng: 20.9192, sys: 1},
            { index: 90, name: '88', lat: 44.5951 , lng: 20.924, sys: 1},
            { index: 91, name: '89', lat: 44.5961 , lng: 20.9288, sys: 1},
            { index: 92, name: '90', lat: 44.5971 , lng: 20.9333, sys: 1},
            { index: 93, name: '91', lat: 44.5981 , lng: 20.9379, sys: 1},
            { index: 94, name: '92', lat: 44.5989 , lng: 20.942, sys: 1},
            { index: 95, name: '93', lat: 44.5979 , lng: 20.9457, sys: 1},
            { index: 96, name: '94', lat: 44.5967 , lng: 20.9502, sys: 1},
            { index: 97, name: '95', lat: 44.5955 , lng: 20.9549, sys: 1},
            { index: 98, name: '96', lat: 44.5944 , lng: 20.9589, sys: 1},
            { index: 99, name: '97', lat: 44.5951 , lng: 20.9628, sys: 1},
            { index: 100, name: 'P-99', lat: 44.5961 , lng: 20.963, sys: 1, portal: true}
        ]},
        {
            ohl: 'DV 453 RP DRMNO - TS PANČEVO 2',
            poles: [
            { index: 102, name: '101', lat: 44.8258 , lng: 20.8541, sys: 1},
            { index: 103, name: '102', lat: 44.8243 , lng: 20.8503, sys: 1},
            { index: 104, name: '103', lat: 44.8228 , lng: 20.8463, sys: 1},
            { index: 105, name: '104', lat: 44.8211 , lng: 20.842, sys: 1},
            { index: 106, name: '105', lat: 44.8193 , lng: 20.8373, sys: 1},
            { index: 107, name: '106', lat: 44.8177 , lng: 20.8333, sys: 1},
            { index: 108, name: '107', lat: 44.8163 , lng: 20.8295, sys: 1},
            { index: 109, name: '108', lat: 44.8174 , lng: 20.8253, sys: 1},
            { index: 110, name: '109', lat: 44.8185 , lng: 20.821, sys: 1},
            { index: 111, name: '110', lat: 44.8197 , lng: 20.8167, sys: 1},
            { index: 112, name: '111', lat: 44.8208 , lng: 20.8125, sys: 1},
            { index: 113, name: '112', lat: 44.8219 , lng: 20.8085, sys: 1},
            { index: 114, name: '113', lat: 44.8228 , lng: 20.8047, sys: 1},
            { index: 115, name: '114', lat: 44.8238 , lng: 20.801, sys: 1},
            { index: 116, name: '115', lat: 44.8248 , lng: 20.7972, sys: 1},
            { index: 117, name: '115a', lat: 44.8257 , lng: 20.7932, sys: 1},
            { index: 118, name: '115b', lat: 44.8267 , lng: 20.7892, sys: 1},
            { index: 119, name: '115c', lat: 44.8276 , lng: 20.7857, sys: 1},
            { index: 120, name: '116', lat: 44.8284 , lng: 20.7827, sys: 1},
            { index: 121, name: '117', lat: 44.8293 , lng: 20.7796, sys: 1},
            { index: 122, name: '118', lat: 44.8306 , lng: 20.775, sys: 1},
            { index: 123, name: '119', lat: 44.8319 , lng: 20.7705, sys: 1},
            { index: 124, name: '120', lat: 44.8329 , lng: 20.7668, sys: 1},
            { index: 125, name: '121', lat: 44.834 , lng: 20.7631, sys: 1},
            { index: 126, name: '122', lat: 44.8352 , lng: 20.759, sys: 1},
            { index: 127, name: '123', lat: 44.8364 , lng: 20.7548, sys: 1},
            { index: 128, name: '124', lat: 44.8377 , lng: 20.75, sys: 1},
            { index: 129, name: '125', lat: 44.839 , lng: 20.7454, sys: 1},
            { index: 130, name: '126', lat: 44.8402 , lng: 20.7411, sys: 1},
            { index: 131, name: '127', lat: 44.8414 , lng: 20.737, sys: 1},
            { index: 132, name: '128', lat: 44.8424 , lng: 20.7334, sys: 1},
            { index: 133, name: '129', lat: 44.8441 , lng: 20.7309, sys: 1},
            { index: 134, name: '130', lat: 44.8462 , lng: 20.7278, sys: 1},
            { index: 135, name: '131', lat: 44.8484 , lng: 20.7245, sys: 1},
            { index: 136, name: '132', lat: 44.8505 , lng: 20.7213, sys: 1},
            { index: 137, name: '133', lat: 44.8529 , lng: 20.7185, sys: 1},
            { index: 138, name: '134', lat: 44.8555 , lng: 20.7155, sys: 1},
            { index: 139, name: '135', lat: 44.8583 , lng: 20.7123, sys: 1},
            { index: 140, name: '136', lat: 44.8611 , lng: 20.7091, sys: 1},
            { index: 141, name: '137', lat: 44.8623 , lng: 20.7077, sys: 1},
            { index: 142, name: '138', lat: 44.865 , lng: 20.7046, sys: 1},
            { index: 143, name: '139', lat: 44.8661 , lng: 20.702, sys: 1},
            { index: 144, name: '140', lat: 44.867 , lng: 20.7002, sys: 1},
            { index: 145, name: 'P-07', lat: 44.8676 , lng: 20.7, sys: 1, portal: true}
        ],
        isOutage: true
        }
    ],
    thunderHits: [
        {lat: 44.64676, lng: 20.54238}
        ,{lat: 44.98554, lng: 20.30449}
        ,{lat: 44.77226, lng: 20.8354}
        ,{lat: 44.60954, lng: 20.52315}
        ,{lat: 44.94221, lng: 20.31301}
        ,{lat: 44.75437, lng: 20.79136}
        ,{lat: 44.76476, lng: 20.91123}
        ,{lat: 44.81026, lng: 20.15562}
        ,{lat: 44.59027, lng: 20.14649}
        ,{lat: 44.57482, lng: 20.69291}
        ,{lat: 44.69188, lng: 20.85928}
        ,{lat: 44.74284, lng: 20.8777}
        ,{lat: 44.8561, lng: 20.70466}
        ,{lat: 44.79425, lng: 20.74212}
        ,{lat: 44.88119, lng: 20.1818}
        ,{lat: 44.90945, lng: 20.55511}
        ,{lat: 44.69885, lng: 20.89557}
        ,{lat: 44.77613, lng: 20.85736}
        ,{lat: 44.68829, lng: 20.6055}
        ,{lat: 44.68793, lng: 20.32204}
        ,{lat: 44.93755, lng: 20.19698}
        ,{lat: 44.88257, lng: 20.85418}
        ,{lat: 44.96699, lng: 20.56404}
        ,{lat: 44.90708, lng: 20.17151}
        ,{lat: 44.81851, lng: 20.92012}
        ,{lat: 44.97256, lng: 20.54086}
        ,{lat: 44.83972, lng: 20.50603}
        ,{lat: 44.96582, lng: 20.8536}
        ,{lat: 44.66022, lng: 20.2776}
        ,{lat: 44.8856, lng: 20.15629}
        ,{lat: 44.64012, lng: 20.23614}
        ,{lat: 44.84129, lng: 20.64884}
        ,{lat: 44.71509, lng: 20.75175}
        ,{lat: 44.94699, lng: 20.80716}
        ,{lat: 44.75854, lng: 20.46061}
        ,{lat: 44.78438, lng: 20.62516}
        ,{lat: 44.75413, lng: 20.73614}
        ,{lat: 44.78415, lng: 20.91141}
        ,{lat: 44.77046, lng: 20.83406}
        ,{lat: 44.94179, lng: 20.29444}
        ,{lat: 44.89927, lng: 20.60938}
        ,{lat: 44.99205, lng: 20.43306}
        ,{lat: 44.58588, lng: 20.37696}
        ,{lat: 44.79725, lng: 20.16177}
        ,{lat: 44.57028, lng: 20.23626}
        ,{lat: 44.89295, lng: 20.19002}
        ,{lat: 44.84938, lng: 20.87605}
        ,{lat: 44.99367, lng: 20.33427}
        ,{lat: 44.89403, lng: 20.59012}
        ,{lat: 44.8713, lng: 20.88183}
        ,{lat: 44.98964, lng: 20.83987}
        ,{lat: 44.63782, lng: 20.21442}
        ,{lat: 44.78736, lng: 20.64426}
        ,{lat: 44.89609, lng: 20.47308}
        ,{lat: 44.80004, lng: 20.28031}
        ,{lat: 44.68609, lng: 20.36721}
        ,{lat: 44.72214, lng: 20.80182}
        ,{lat: 44.94246, lng: 20.17644}
        ,{lat: 44.76622, lng: 20.85627}
        ,{lat: 44.76653, lng: 20.59275}
        ,{lat: 44.93163, lng: 20.75217}
        ,{lat: 44.57844, lng: 20.32572}
        ,{lat: 44.6298, lng: 20.76821}
        ,{lat: 44.57931, lng: 20.55184}
        ,{lat: 44.61489, lng: 20.24408}
        ,{lat: 44.89997, lng: 20.29547}
        ,{lat: 44.6225, lng: 20.76131}
        ,{lat: 44.96124, lng: 20.67641}
        ,{lat: 44.70673, lng: 20.22669}
        ,{lat: 44.91511, lng: 20.70781}
        ,{lat: 44.71466, lng: 20.16769}
        ,{lat: 44.61724, lng: 20.59856}
        ,{lat: 44.7049, lng: 20.44887}
        ,{lat: 44.98985, lng: 20.38847}
        ,{lat: 44.9318, lng: 20.5521}
        ,{lat: 44.84996, lng: 20.21878}
        ,{lat: 44.63374, lng: 20.37065}
        ,{lat: 44.93815, lng: 20.39523}
        ,{lat: 44.62073, lng: 20.69652}
        ,{lat: 44.89374, lng: 20.42194}
        ,{lat: 44.58978, lng: 20.37084}
        ,{lat: 44.73281, lng: 20.26769}
        ,{lat: 44.57361, lng: 20.41283}
        ,{lat: 44.79377, lng: 20.36175}
        ,{lat: 44.6287, lng: 20.34003}
        ,{lat: 44.61534, lng: 20.63704}
        ,{lat: 44.66281, lng: 20.31847}
        ,{lat: 44.7059, lng: 20.51688}
        ,{lat: 44.61587, lng: 20.21425}
        ,{lat: 44.79585, lng: 20.28338}
        ,{lat: 44.81293, lng: 20.32167}
        ,{lat: 44.8505, lng: 20.51564}
        ,{lat: 44.67358, lng: 20.5315}
        ,{lat: 44.98672, lng: 20.80121}
        ,{lat: 44.85605, lng: 20.51313}
        ,{lat: 44.63034, lng: 20.51923}
        ,{lat: 44.85641, lng: 20.36819}
        ,{lat: 44.8916, lng: 20.48218}
        ,{lat: 44.95684, lng: 20.53802}
        ,{lat: 44.78777, lng: 20.73091}
        ,{lat: 44.77145, lng: 20.78869}
        ,{lat: 44.87434, lng: 20.85245}
        ,{lat: 44.81548, lng: 20.18479}
        ,{lat: 44.6089, lng: 20.41501}
        ,{lat: 44.7788, lng: 20.28869}
        ,{lat: 44.94514, lng: 20.54102}
        ,{lat: 44.84765, lng: 20.66143}
        ,{lat: 44.78229, lng: 20.79552}
        ,{lat: 44.79903, lng: 20.24459}
        ,{lat: 44.6375, lng: 20.53298}
        ,{lat: 44.88072, lng: 20.89381}
        ,{lat: 44.79497, lng: 20.48997}
        ,{lat: 44.75941, lng: 20.24628}
        ,{lat: 44.88109, lng: 20.29079}
        ,{lat: 44.82337, lng: 20.80819}
        ,{lat: 44.65418, lng: 20.76145}
        ,{lat: 44.5663, lng: 20.15655}
        ,{lat: 44.87818, lng: 20.29675}
        ,{lat: 44.59175, lng: 20.60536}
        ,{lat: 44.88386, lng: 20.23424}
        ,{lat: 44.82945, lng: 20.24441}
        ,{lat: 44.95026, lng: 20.46811}
        ,{lat: 44.64831, lng: 20.33791}
        ,{lat: 44.61869, lng: 20.15008}
        ,{lat: 44.92837, lng: 20.4861}
        ,{lat: 44.72373, lng: 20.40695}
        ,{lat: 44.79257, lng: 20.25162}
        ,{lat: 44.6406, lng: 20.75258}
        ,{lat: 44.86951, lng: 20.1406}
        ,{lat: 44.67541, lng: 20.91529}
        ,{lat: 44.85702, lng: 20.66768}
        ,{lat: 44.92472, lng: 20.66624}
        ,{lat: 44.58469, lng: 20.27099}
        ,{lat: 44.76245, lng: 20.76695}
        ,{lat: 44.64399, lng: 20.41774}
        ,{lat: 44.80117, lng: 20.14841}
        ,{lat: 44.79018, lng: 20.51736}
        ,{lat: 44.57068, lng: 20.23741}
        ,{lat: 44.89913, lng: 20.67443}
        ,{lat: 44.89835, lng: 20.55878}
        ,{lat: 44.93655, lng: 20.40426}
        ,{lat: 44.84246, lng: 20.22134}
        ,{lat: 44.78791, lng: 20.89948}
        ,{lat: 44.73398, lng: 20.4975}
        ,{lat: 44.66483, lng: 20.44993}
        ,{lat: 44.71221, lng: 20.24957}
        ,{lat: 44.73309, lng: 20.41113}
        ,{lat: 44.56474, lng: 20.47781}
        ,{lat: 44.57743, lng: 20.66065}
        ,{lat: 44.62139, lng: 20.3835}
        ,{lat: 44.90009, lng: 20.46257}
        ,{lat: 44.61528, lng: 20.31431}
        ,{lat: 44.62961, lng: 20.24516}
        ,{lat: 44.65583, lng: 20.64731}
        ,{lat: 44.98849, lng: 20.32925}
        ,{lat: 44.81162, lng: 20.31644}
        ,{lat: 44.79079, lng: 20.59491}
        ,{lat: 44.62552, lng: 20.31118}
        ,{lat: 44.76625, lng: 20.87455}
        ,{lat: 44.99416, lng: 20.15476}
        ,{lat: 44.7621, lng: 20.50229}
        ,{lat: 44.96018, lng: 20.73807}
        ,{lat: 44.6967, lng: 20.47542}
        ,{lat: 44.68116, lng: 20.8992}
        ,{lat: 44.5976, lng: 20.32032}
        ,{lat: 44.78951, lng: 20.82952}
        ,{lat: 44.78992, lng: 20.78628}
        ,{lat: 44.96361, lng: 20.89868}
        ,{lat: 44.84058, lng: 20.539}
        ,{lat: 44.93778, lng: 20.79325}
        ,{lat: 44.64682, lng: 20.19773}
        ,{lat: 44.80286, lng: 20.8419}
        ,{lat: 44.73701, lng: 20.47113}
        ,{lat: 44.77455, lng: 20.56417}
        ,{lat: 44.59441, lng: 20.14772}
        ,{lat: 44.65544, lng: 20.36279}
        ,{lat: 44.86511, lng: 20.36056}
        ,{lat: 44.90795, lng: 20.82399}
        ,{lat: 44.71941, lng: 20.92313}
        ,{lat: 44.91211, lng: 20.58091}
        ,{lat: 44.85606, lng: 20.82769}
        ,{lat: 44.69393, lng: 20.70255}
        ,{lat: 44.58707, lng: 20.58233}
        ,{lat: 44.57584, lng: 20.15871}
        ,{lat: 44.77352, lng: 20.49784}
        ,{lat: 44.80243, lng: 20.14581}
        ,{lat: 44.85379, lng: 20.52666}
        ,{lat: 44.67341, lng: 20.20966}
        ,{lat: 44.86129, lng: 20.34209}
        ,{lat: 44.80653, lng: 20.2314}
        ,{lat: 44.88691, lng: 20.61216}
        ,{lat: 44.80437, lng: 20.65321}
        ,{lat: 44.94057, lng: 20.5212}
        ,{lat: 44.66502, lng: 20.84441}
        ,{lat: 44.79768, lng: 20.55891}
        ,{lat: 44.60148, lng: 20.17868}
        ,{lat: 44.90403, lng: 20.49339}
        ,{lat: 44.83253, lng: 20.33661}
        ,{lat: 44.80805, lng: 20.64587}
        ,{lat: 44.62191, lng: 20.40455}
        ,{lat: 44.6866, lng: 20.20187}
        ,{lat: 44.72238, lng: 20.47621}
        ,{lat: 44.96838, lng: 20.53153}
        ,{lat: 44.60794, lng: 20.3772}
        ,{lat: 44.73174, lng: 20.43677}
        ,{lat: 44.65037, lng: 20.54646}
        ,{lat: 44.94243, lng: 20.90371}
        ,{lat: 44.60269, lng: 20.43471}
        ,{lat: 44.73657, lng: 20.5705} 
    ]
}